import React, { useEffect, useId, useMemo, useState } from "react";
import {
  ReceiptIndianRupee,
  UserCircle,
  History,
  Calendar,
  FileText,
  MessageSquare,
  Landmark,
  Activity,
  ArrowDownRight,
  ArrowUpRight,
  Loader2,
} from "lucide-react";
import DivTag from "../../Components/DivComponent/DivTag";
import ReportHeading from "../../Components/ReportHeadings/ReportHeadings";
import { motion } from "framer-motion";
import InputWithLabel from "../../Components/InputComponent/InputWithLabel";
import Button from "../../Components/ButtonComponent/Button";
import { ToastContainer } from "react-toastify";
import {
  AddAmountWalletService,
  CustomerListService,
  DeductAmountWalletService,
  verifyPinsService,
  fetchBalanceAll,
  getRecentTransactions,
} from "../../../services/walletservice";
import PopMenu from "../../../components/Dialog/PopMenu";
import { showErrorToast, showSuccessToast } from "../../../utils/toastUtils";
import Seo from "../../../components/SeoComponent/Seo";
import Loader from "../../../components/Loader/Loader";
import PaginationData from "../../../components/PaginationData";
import TransactionMain from "./TxnCards";
const WalletBalanceManagement = () => {
  const [customerList, setCustomerLists] = useState([]);
  const [addharNumber, setAdharNumber] = useState("");
  const [panNumber, setPanNumer] = useState("");
  const [totalData, setTotalData] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationData, setPaginationData] = useState();
  const [mobileNumber, setMobileNumber] = useState("");
  const [userId, setUserId] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [addPopUp, setAddPopUp] = useState(false);
  const [deductPopUp, setDeductPopUp] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [remarks, setRemark] = useState("");
  const [amount, setAmount] = useState(0);
  const [balance, setBalance] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isPinVerify, setIsPinVerify] = useState(false);
  const [lockPin, setLockPin] = useState("");
  const [pinMsg, setPinMsg] = useState("");
  const [selectedAccount, setSelectedAccount] = useState("");
  const [balanceAmt, setBalanceAmt] = useState(null);
  const [payoutBal, setPayoutBal] = useState(0);
  const [selectedName, setSelectedName] = useState("");
  const [loading, setLoading] = useState(false);
  const [filteredCustomerList, setFilteredCustomerList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showLastTransactions, setShowLastTransactions] = useState(false);
  const [recentTxns, setRecentTxns] = useState(null);
  const [txnLoadnig, setTxnLoading] = useState(false);
  const [verifyPinLoading, setVerifyPinLoading] = useState(false);
  const [addFundLoading, setAddFundLoading] = useState(false);
  const [deductFundLoading, setDeductFundLoading] = useState(false);

  const getCustomerLists = async () => {
    try {
      setIsLoading(true);
      const response = await CustomerListService({
        aadhar_number: addharNumber,
        pan_number: panNumber,
        mobile: mobileNumber,
        userid: userId.toUpperCase(),
        company_name: companyName,
        total_data: userId !== "" ? 1 : totalData,
        currentPage: userId !== "" ? 1 : currentPage,
      });

      setIsLoading(false);
      setCustomerLists(response.data);
      setPaginationData(response.pagination);
      // if (response?.status === "success") {
      //   setShowLastTransactions(true);
      // }

      if (!userId) return;
      fetchRecentTxs();
    } catch (error) {
      setIsLoading(false);
      return;
    }
  };

  // Global search filter function
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);

    if (value === "") {
      setFilteredCustomerList(customerList);
    } else {
      const filtered = customerList.filter((item) => {
        const appId = item?.user_id?.toString().toLowerCase() || "";
        const companyName =
          (item?.company_details?.company_name === "Dummy Company Name"
            ? item?.name
            : item?.company_details?.company_name
          )?.toLowerCase() || "";
        const authorizedPersonName =
          item?.company_details?.authorized_person_name?.toLowerCase() || "";

        return (
          appId.includes(value) ||
          companyName.includes(value) ||
          authorizedPersonName.includes(value)
        );
      });
      setFilteredCustomerList(filtered);
    }
  };

  // Reset filter when customerList changes
  useEffect(() => {
    setFilteredCustomerList(customerList);
  }, [customerList]);

  const fetchRecentTxs = async (params) => {
    setTxnLoading(true);
    try {
      const res = await getRecentTransactions({ user_id: userId });

      if (res?.status?.code === 200) {
        setShowLastTransactions(true);
        setRecentTxns(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setTxnLoading(false);
    }
  };

  // useEffect(() => {
  //   if(!userId) return
  //   fetchRecentTxs()
  // }, [userId])

  const handleOpenAddWalletpop = (userId, balance, name) => {
    setSelectedUserId(userId);
    setBalance(balance);
    setAddPopUp(true);
    setSelectedName(name);
    return;
  };
  const handleOpenDeductWalletpop = (userId, balance, name) => {
    setSelectedUserId(userId);
    setBalance(balance);
    setDeductPopUp(true);
    setSelectedName(name);
    return;
  };
  const AddWalletAmount = async () => {
    setAddFundLoading(true);
    try {
      setIsLoading(true);
      const response = await AddAmountWalletService({
        userId: selectedUserId,
        amount: amount,
        transaction_type: selectedAccount,
        remarks: remarks,
      });
      if (response.status === "success") {
        setLockPin("");
        setIsLoading(false);
        setAddPopUp(false);
        setAmount(0);
        showSuccessToast(response.message || "Amount Add Successfully");
        return;
      }
      setIsLoading(false);
      showErrorToast(response.message);
      setAddPopUp(false);
    } catch (error) {
      setIsLoading(false);
      showErrorToast("Failed to add amount");
      setAddPopUp(false);
      return;
    } finally {
      setAddFundLoading(false);
    }
  };
  const DeductWalletAmount = async () => {
    setDeductFundLoading(true);
    try {
      setIsLoading(true);
      const response = await DeductAmountWalletService({
        userId: selectedUserId,
        amount: amount,
        transaction_type: selectedAccount,
        remarks: remarks,
      });

      if (response.status === "success") {
        setLockPin("");
        setIsLoading(false);
        setDeductPopUp(false);
        setAmount(0);
        showSuccessToast(response.message || "Deduct Successfully");
        return;
      }
      setLockPin("");
      setIsLoading(false);
      showErrorToast(response.message);
      setAddPopUp(false);
    } catch (error) {
      setIsLoading(false);
      showErrorToast("Failed to add amount");
      setAddPopUp(false);
      return;
    } finally {
      setDeductFundLoading(false);
    }
  };
  async function verifyLockPins() {
    try {
      if (lockPin.length < 6) {
        setIsPinVerify(false);
        return;
      }
      setVerifyPinLoading(true);
      const response = await verifyPinsService(lockPin);

      if (response) {
        console.log("pin verify response", response);
      }
      if (response.status.code === 200) {
        setIsPinVerify(true);
        setPinMsg(
          response.status.message ||
            response?.message ||
            response?.error?.message ||
            response?.data?.error?.message ||
            response?.data?.message,
        );
        return;
      }
      setPinMsg(
        response.message ||
          response?.message ||
          response?.error?.message ||
          response?.data?.error?.message ||
          response?.data?.message,
      );
      setIsPinVerify(false);
    } catch (error) {
      return error;
    } finally {
      setVerifyPinLoading(false);
    }
  }

  useEffect(() => {
    console.log("verifyPinLoading", verifyPinLoading);
  }, [verifyPinLoading]);

  function handleSetPage(page) {
    setCurrentPage(page);
  }
  
  useEffect(() => {
    getCustomerLists();
  }, [addPopUp, deductPopUp, currentPage]);

  useEffect(() => {
    setTimeout(() => {
      verifyLockPins();
    }, 500);
  }, [lockPin]);

  const handleChange = async (e) => {
    const selectedType = e.target.value;
    setSelectedAccount(selectedType);
    setBalanceAmt(null); // reset before fetch
    setLoading(true);
    try {
      const response = await fetchBalanceAll({
        account_type: selectedType,
        user_id: userId,
      });

      setBalanceAmt(response?.data?.balance);
    } catch (error) {
      setBalanceAmt("Error fetching balance");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const getPayoutBalance = async () => {
      try {
        const response = await fetchBalanceAll({
          account_type: "Payout Account",
          user_id: userId,
        });
        setPayoutBal(response?.data?.balance);
      } catch (error) {
        setPayoutBal("Error Fetching Bal");
      }
    };

    if (userId) {
      getPayoutBalance();
    }
  }, [userId]); // Only run effect when userId is available

  return (
    <motion.div
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1.2 }}
    >
      <Seo />
      {isLoading && <Loader />}
      <DivTag id="" className="mt-8 bg-white py-4">
        <ReportHeading name="Wallet Balance Management" />
        <DivTag className="flex mt-3 justify-center items-center">
          <InputWithLabel
            DivclassName="w-full md:w-1/4 px-3 md:mb-0"
            label="User Id "
            type="text"
            name="from_date"
            id="s"
            min={12}
            maxLength={12}
            placeholder={"USEID01"}
            value={userId.toUpperCase()}
            onChange={(e) => setUserId(e.target.value)}
          />
          <InputWithLabel
            DivclassName="w-full md:w-1/4 px-3 md:mb-0"
            label="Aadhar Number "
            type="number"
            name="from_date"
            id="s"
            min={12}
            maxLength={12}
            placeholder={"Aadhar number"}
            value={addharNumber}
            onChange={(e) => setAdharNumber(e.target.value)}
          />
          <InputWithLabel
            DivclassName="w-full md:w-1/4 px-3 md:mb-0"
            label="Pan Number "
            type="text"
            name="from_date"
            id="s"
            placeholder={"Pan number"}
            value={panNumber}
            onChange={(e) => setPanNumer(e.target.value)}
          />

          <InputWithLabel
            DivclassName="w-full md:w-1/4 px-3 md:mb-0"
            label="Mobile "
            type="number"
            name="from_date"
            id="s"
            placeholder={"92822911*"}
            value={mobileNumber}
            onChange={(e) => setMobileNumber(e.target.value)}
          />
          <InputWithLabel
            DivclassName="w-full md:w-1/4 px-3 md:mb-0"
            label="company Name "
            type="text"
            name="from_date"
            id="s"
            placeholder={"company name "}
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
          />
        </DivTag>
        {/* Add Pop up */}
        <PopMenu
          visible={addPopUp}
          onClose={() => {
            setPinMsg("");
            setAmount(0);
            setLockPin("");
            setAddPopUp(false);
          }}
          className="w-full max-w-xl h-fit"
          title="Add Amount"
        >
          {/* Summary info card */}
          <div className="bg-white shadow-md rounded-md p-2 mb-2">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm text-blue-900 font-semibold text-center">
              <p>User ID: {selectedUserId}</p>
              <p>Name: {selectedName}</p>
              <p>Wallet Bal: ₹{balance}</p>
              <p>Payout Bal: ₹{payoutBal}</p>
            </div>
          </div>

          {/* Form fields */}
          <div className="bg-white shadow-md rounded-md p-2 w-full">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              {/* Amount */}
              <div className="col-span-1">
                <label className="text-sm font-bold text-gray-700">
                  Amount <span className="text-red-500 text-md">*</span>
                </label>
                <input
                  type="number"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  name="amount"
                  placeholder="Enter Amount"
                  className="mt-1 border-2 rounded-md border-sky-400 shadow-sm outline-none p-2 w-full text-black text-sm"
                />
                {amount < 0.01 && (
                  <p className="text-red-500 text-xs mt-1">
                    Amount must be greater than 0.01
                  </p>
                )}
              </div>

              {/* Transaction Type */}
              <div className="col-span-1">
                <label className="text-sm font-bold text-gray-700">
                  Transaction Type
                </label>
                <select
                  id="accountSelect"
                  value={selectedAccount}
                  onChange={handleChange}
                  className="mt-1 w-full border-2 border-cyan-500 rounded px-3 py-2 text-sm text-black"
                >
                  <option value="" disabled>
                    Select Transaction Type
                  </option>
                  <option value="Business Wallet">Business Wallet</option>
                  <option value="Payout Account">Payout Account</option>
                </select>
                {loading && (
                  <p className="text-sm text-blue-600 mt-1">
                    Fetching balance...
                  </p>
                )}
                {balanceAmt !== null && !loading && (
                  <p className="text-sm text-green-700 mt-1">
                    Balance: ₹{parseFloat(balanceAmt).toFixed(2)}
                  </p>
                )}
              </div>

              {/* Remark */}
              <div className="col-span-1">
                <label className="text-sm font-bold text-gray-700">
                  Remark
                </label>
                <input
                  type="text"
                  value={remarks}
                  onChange={(e) => setRemark(e.target.value)}
                  name="remarks"
                  placeholder="Enter Remark"
                  className="mt-1 border-2 rounded-md border-sky-400 shadow-sm outline-none p-2 w-full text-black text-sm"
                />
              </div>

              {/* Lock Pin */}
              <div className="col-span-1">
                <label className="text-sm font-bold text-gray-700">
                  Lock Pin
                </label>
                <input
                  type="password"
                  value={lockPin}
                  onChange={(e) => setLockPin(e.target.value)}
                  name="lock_pin"
                  placeholder="*****"
                  className={`mt-1 border-2 rounded-md shadow-sm outline-none p-2 w-full text-black text-sm ${
                    isPinVerify ? "border-green-400" : "border-red-400"
                  }`}
                />
                {verifyPinLoading && (
                  <span
                    className={`text-xs font-semibold ${isPinVerify ? "text-green-600" : "text-red-600"}`}
                  >
                    {verifyPinLoading && (
                      <p className="text-green-600 flex items-center gap-2">
                        <Loader2 className="animate-spin" /> Verifying...
                      </p>
                    )}
                  </span>
                )}
                {pinMsg && (
                  <span
                    className={`text-xs font-semibold ${isPinVerify ? "text-green-600" : "text-red-600"}`}
                  >
                    {pinMsg}
                  </span>
                )}
              </div>
            </div>

            {/* Submit Button */}
            <div className="mt-6 flex justify-center">
              <button
                disabled={
                  amount <= 0 || isPinVerify === false || addFundLoading
                }
                onClick={AddWalletAmount}
                className={`px-4 py-2 rounded text-white flex items-center justify-center gap-2 font-semibold text-sm ${
                  amount <= 0 || isPinVerify === false
                    ? "bg-slate-300 cursor-not-allowed"
                    : "bg-blue-500 hover:bg-blue-600"
                }`}
              >
                {addFundLoading ? (
                  <>
                    <Loader2 className="animate-spin text-white" />{"Adding... "}
                  </>
                ) : (
                  "Add Fund"
                )}
              </button>
            </div>
          </div>
        </PopMenu>

        {/* Deduct Pop up */}
        <PopMenu
          visible={deductPopUp}
          onClose={() => {
            setPinMsg("");
            setAmount(0);
            setLockPin("");
            setDeductPopUp(false);
          }}
          className="w-full max-w-xl h-fit"
          title="Deduct Amount"
        >
          {/* Summary Info */}
          <div className="bg-white shadow-md rounded-md p-2 mb-2">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm text-blue-900 font-semibold text-center">
              <p>User ID: {selectedUserId}</p>
              <p>Name: {selectedName}</p>
              <p>Available Bal: ₹{balance}</p>
              <p>Payout Bal: ₹{payoutBal}</p>
            </div>
          </div>

          {/* Form Section */}
          <div className="bg-white shadow-md rounded-md p-2 w-full">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              {/* Amount Field */}
              <div className="col-span-1">
                <label className="text-sm font-bold text-gray-700">
                  Amount <span className="text-red-500 text-md">*</span>
                </label>
                <input
                  type="number"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  name="amount"
                  placeholder="Enter Amount"
                  className="mt-1 border-2 rounded-md border-sky-400 shadow-sm outline-none p-2 w-full text-black text-sm"
                />
                {/* {(amount < 0 || amount > balance) && (
                  <p className="text-red-500 text-xs mt-1">
                    {amount < 0
                      ? "Amount must be greater than 0"
                      : "Deduct amount must be lower than balance"}
                  </p>
                )} */}
                {(amount < 0.01 || amount > balance) && (
                  <p className="text-red-500 text-xs mt-1">
                    {amount < 0.01
                      ? "Amount must be at least ₹0.01"
                      : "Deduct amount must be lower than balance"}
                  </p>
                )}
              </div>

              {/* Transaction Type */}
              <div className="col-span-1">
                <label className="text-sm font-bold text-gray-700">
                  Transaction Type
                </label>
                <select
                  id="accountSelect"
                  value={selectedAccount}
                  onChange={handleChange}
                  className="mt-1 w-full border-2 border-cyan-500 rounded px-3 py-2 text-sm text-black"
                >
                  <option value="" disabled>
                    Select Transaction Type
                  </option>
                  <option value="Business Wallet">Business Wallet</option>
                  <option value="Payout Account">Payout Account</option>
                </select>
                {loading && (
                  <p className="text-sm text-blue-600 mt-1">
                    Fetching balance...
                  </p>
                )}
                {balanceAmt !== null && !loading && (
                  <p className="text-sm text-green-700 mt-1">
                    Balance: ₹{parseFloat(balanceAmt).toFixed(2)}
                  </p>
                )}
              </div>

              {/* Remark */}
              <div className="col-span-1">
                <label className="text-sm font-bold text-gray-700">
                  Remark
                </label>
                <input
                  type="text"
                  value={remarks}
                  onChange={(e) => setRemark(e.target.value)}
                  name="remarks"
                  placeholder="Enter Remark"
                  className="mt-1 border-2 rounded-md border-sky-400 shadow-sm outline-none p-2 w-full text-black text-sm"
                />
              </div>

              {/* Lock Pin */}
              <div className="col-span-1">
                <label className="text-sm font-bold text-gray-700">
                  Lock Pin
                </label>
                <input
                  type="password"
                  value={lockPin}
                  onChange={(e) => setLockPin(e.target.value)}
                  name="lock_pin"
                  placeholder="*****"
                  className={`mt-1 border-2 rounded-md shadow-sm outline-none p-2 w-full text-black text-sm ${
                    isPinVerify ? "border-green-400" : "border-red-400"
                  }`}
                />
                {verifyPinLoading && (
                  <span
                    className={`text-xs font-semibold ${isPinVerify ? "text-green-600" : "text-red-600"}`}
                  >
                    {verifyPinLoading && (
                      <p className="text-green-600 flex items-center gap-2">
                        <Loader2 className="animate-spin" /> Verifying...
                      </p>
                    )}
                  </span>
                )}
                {pinMsg && (
                  <span
                    className={`text-xs font-semibold ${isPinVerify ? "text-green-600" : "text-red-600"}`}
                  >
                    {pinMsg}
                  </span>
                )}
              </div>
            </div>

            {/* Submit Button */}
            <div className="mt-6 flex justify-center">
              <button
                disabled={
                  amount <= 0.01 || amount > balance || isPinVerify === false
                }
                onClick={DeductWalletAmount}
                className={`px-4 py-2 rounded text-white font-semibold text-sm  flex items-center justify-center gap-2 ${
                  amount <= 0.01 || amount > balance || isPinVerify === false
                    ? "bg-slate-300 cursor-not-allowed"
                    : "bg-blue-500 hover:bg-blue-600"
                }`}
              >
                {deductFundLoading ? (
                  <>
                    <Loader2 className="animate-spin text-white" />{"Deducting... "}
                  </>
                ) : (
                  "Deduct Fund"
                )}
              </button>
            </div>
          </div>
        </PopMenu>

        <div className="flex justify-center items-center my-5 gap-5">
          <div className="flex flex-col">
            <label htmlFor="totalData">Total Data</label>
            <select
              name=""
              id="totalData"
              className="border-2 border-orange-200 bg-white shadow-sm py-2 rounded-md"
              value={totalData}
              onChange={(e) => setTotalData(e.target.value)}
            >
              <option value="#" disabled selected>
                Select Data Per Page
              </option>
              <option value="100">100</option>
            </select>
          </div>
          <Button
            type="button"
            className="text-center text-white bg-blue-700 shadow-lg bg-gradient-to-r from-blue-900 mt-4
                         via-teal-400 to-purple-900 font-semibold p-0 rounded-md px-2 py-1 text-lg hover:bg-red-300"
            id="submitApiUserKyc"
            name="submitApiUserKyc"
            onClick={getCustomerLists}
          >
            Submit
          </Button>
        </div>

        <div className="flex justify-end mb-1">
          <div className="w-full md:w-1/6 mr-4">
            <input
              type="text"
              placeholder="🔍 Search by App ID, Company Name, or Authorized Person..."
              value={searchTerm}
              onChange={handleSearch}
              className="w-full px-4 py-2 border border-blue-500 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent shadow-sm"
            />
            {searchTerm && (
              <p className="text-sm text-gray-600 mt-2">
                Found {filteredCustomerList.length} result(s)
              </p>
            )}
          </div>
        </div>
        <DivTag className="overflow-x-auto">
          <table id="table " className="min-w-full divide-y divide-gray-200 ">
            <thead className="bg-gray-50 top-0">
              <tr className="bg-blue-700 text-center text-white">
                <th className="border-r p-1">S No.</th>
                <th className="border-r p-1">API ID</th>
                <th className="border-r p-1">Auth Sign Name</th>
                <th className="border-r p-1">API Name</th>
                <th className="border-r p-1">Business Wallet</th>
                <th className="border-r p-1">Payout Wallet</th>
                <th className="border-r p-1">Hold Bal</th>
                <th className="border-r p-1">Add Fund</th>
                <th className="border-r p-1">Deduct Fund</th>
              </tr>
            </thead>
            <tbody>
              {filteredCustomerList && filteredCustomerList.length > 0 ? (
                filteredCustomerList.map((item, index) => (
                  <tr key={index} className="text-center hover:bg-gray-50">
                    <td className="border p-1">
                      {(currentPage - 1) * (paginationData?.per_page || 10) +
                        index +
                        1}
                    </td>
                    <td className="border p-1 font-medium">{item?.user_id}</td>
                    <td className="border p-1">
                      {item?.company_details?.authorized_person_name || "N/A"}
                    </td>
                    <td className="border p-1">
                      {item?.company_details?.company_name ===
                      "Dummy Company Name"
                        ? item?.name
                        : item?.company_details?.company_name}
                    </td>
                    <td className="p-1 border font-bold text-green-600">
                      ₹ {item?.balance}
                    </td>
                    <td className="p-1 border font-bold text-blue-600">
                      ₹ {payoutBal || "0"}
                    </td>
                    <td className="p-1 border font-bold text-red-600">
                      ₹ {item?.hold_balance}
                    </td>
                    <td className="border p-1">
                      <button
                        className="btn bg-blue-500 text-white rounded-md px-3 py-1 hover:bg-blue-600 transition-colors"
                        onClick={() =>
                          handleOpenAddWalletpop(
                            item.user_id,
                            item.balance,
                            item.name,
                          )
                        }
                      >
                        Add
                      </button>
                    </td>
                    <td className="border p-1">
                      <button
                        className="btn bg-red-500 text-white rounded-md px-3 py-1 hover:bg-red-600 transition-colors"
                        onClick={() =>
                          handleOpenDeductWalletpop(
                            item.user_id,
                            item.balance,
                            item.name,
                          )
                        }
                      >
                        Deduct
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center p-4 text-gray-500">
                    {searchTerm
                      ? "No results found. Try a different search term."
                      : "No customers available."}
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {/* last 10 transactions card */}

          {showLastTransactions && (
            <TransactionMain
              recentTxns={recentTxns}
              showLastTransactions={showLastTransactions}
              loading={txnLoadnig}
            />
          )}

          <div className="flex justify-center my-2">
            <PaginationData
              currentPage={currentPage}
              lastPage={paginationData?.last_page}
              handlePage={handleSetPage}
            />
          </div>
        </DivTag>

        <ToastContainer />
      </DivTag>
    </motion.div>
  );
};
export default WalletBalanceManagement;
